const Styles = {
    SIDE_PADDING: '20px',
    ROW_PADDING: '10px',
    DRAWER_WIDTH: 240,
    DRAWER_WIDTH_CLOSED: 65,
    HEADER_HEIGHT: 87,
    SIDE_MENU_PADDING: 24,
}

export default Styles
